import HTTP from "@/_helpers/http";
import { BROKERSBANK__API } from "@/_helpers/urls";
import { BROKERSBANK__MUTATIONS } from "../mutation-types";
import { BROKERSBANK__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// Utility function to filter out null or undefined fields
function filterObject(obj) {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));
}

// State
const state = {
  banks: [],
  currencies: [],
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [BROKERSBANK__MUTATIONS.GETBROKERSBANK](state, data) {
    state.banks = data;
  },
  [BROKERSBANK__MUTATIONS.GETCURRENCIES](state, data) {
    state.currencies = data;
  },
};

// Actions
const actions = {
  async [BROKERSBANK__ACTIONS.GETBROKERSBANK]({ commit, state }) {
    try {
      const url = `${BROKERSBANK__API.GETBROKERSBANK}`;
      const response = await HTTP().get(url);

      commit(BROKERSBANK__MUTATIONS.GETBROKERSBANK, response.data);
    } catch (error) {
      console.log(error);
    }
  },
  async [BROKERSBANK__ACTIONS.GETCURRENCIES]({ commit, state }) {
    try {
      const url = `${BROKERSBANK__API.GETCURRENCIES}`;
      const response = await HTTP().get(url);

      commit(BROKERSBANK__MUTATIONS.GETCURRENCIES, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [BROKERSBANK__ACTIONS.BROKERSBANK]({ dispatch }, parameter) {
    try {
      const formData = new FormData();

      const filteredParameter = filterObject(parameter);

      for (const [key, value] of Object.entries(filteredParameter)) {
        formData.append(key, value);
      }

      const response = await HTTP().post(
        BROKERSBANK__API.BROKERSBANK,
        formData
      );

      if (response.status === 200) {
        toast.success("Successfully Created");
        await dispatch(BROKERSBANK__ACTIONS.GETBROKERSBANK);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to create");
    }
  },

  async [BROKERSBANK__ACTIONS.UPDATEBANK]({ dispatch }, parameter) {
    try {
      const formData = new FormData();

      const fields = [
        "id",
        "usd_to_inr",
        "currency",
        "commission",
        "processing_time",
        "beneficiary_name",
        "beneficiary_address",
        "beneficiary_account",
        "beneficiary_IBAN",
        "beneficiary_bank_name",
        "beneficiary_bank_address",
        "beneficiary_bank_swift",
        "ifsc_code",
        "methods_logo_url",
        "country_access",
        "newFile",
        "upi"
      ];

      for (const field of fields) {
        if (parameter[field]) {
          formData.append(field, parameter[field]);
        }
      }

      const response = await HTTP().patch(
        BROKERSBANK__API.UPDATEBANK,
        formData
      );

      if (response.status === 200) {
        toast.success("Successfully Updated");
        await dispatch(BROKERSBANK__ACTIONS.GETBROKERSBANK);
      }
    } catch (error) {
      console.error("Error updating server config:", error);
      toast.error(error.response.data.message);
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
